var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharedgoalsAmico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 338.966,
    height: 303.083,
    viewBox: "0 0 338.966 303.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shared_goals-amico",
    "data-name": "Shared goals-amico",
    transform: "translate(-9.1 -36.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--hand-2--inject-650",
    transform: "translate(152.972 65.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9512",
    "data-name": "Path 9512",
    d: "M350.035,133.9a89.062,89.062,0,0,1,21.388,5.226c10.7,4.22,17.1,13.75,29.856,16.556,0,0,15.987,19.693,0,49.676l-22.352-3.411a26.064,26.064,0,0,0-9.847.345c-4.4,1.027-12.336,2.054-23.371.26Z",
    transform: "translate(-252.836 -94.242)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9513",
    "data-name": "Path 9513",
    d: "M239.417,248.83l16.95,9.875v68.314l-17.027-10Z",
    transform: "translate(-221.279 -128.34)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9514",
    "data-name": "Path 9514",
    d: "M239.417,248.83l16.95,9.875v68.314l-17.027-10Z",
    transform: "translate(-221.279 -128.34)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9515",
    "data-name": "Path 9515",
    d: "M235.885,241.234l6.33-21.1c4.572-6.421,7.547-14.32,7.547-21.311,0-11.513-8.081-16.176-18.047-10.423s-18.054,19.756-18.054,31.27c0,5.662,1.955,9.664,5.127,11.591h0l.288.169Z",
    transform: "translate(-213.66 -109.68)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9516",
    "data-name": "Path 9516",
    d: "M239.417,92.5l16.95,9.875V170.7L239.34,160.687Z",
    transform: "translate(-221.279 -81.96)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9517",
    "data-name": "Path 9517",
    d: "M239.417,92.5l16.95,9.875V170.7L239.34,160.687Z",
    transform: "translate(-221.279 -81.96)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9518",
    "data-name": "Path 9518",
    d: "M342.25,99.515l-.26-.155.253.155Z",
    transform: "translate(-251.733 -83.995)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9519",
    "data-name": "Path 9519",
    d: "M310.53,92.295l-15.508-9.031h0c-14.066-8.728-33.759-7.821-55.6,4.79a.288.288,0,0,0-.077.049l17.027,9.847C277.474,85.747,296.6,84.488,310.53,92.295Z",
    transform: "translate(-221.279 -77.514)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9520",
    "data-name": "Path 9520",
    d: "M340.56,98.53l1.006.584Z",
    transform: "translate(-251.308 -83.749)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9521",
    "data-name": "Path 9521",
    d: "M311.368,97.2l-.253-.155-1.006-.584c-13.933-7.807-33.056-6.548-54.156,5.627V170.4c-9.959,5.753-18.033,19.735-18.033,31.227s8.074,16.176,18.033,10.409v68.321c42.621-24.616,77.183-84.469,77.183-133.694C333.136,122.548,324.837,105.464,311.368,97.2Z",
    transform: "translate(-220.857 -81.681)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9522",
    "data-name": "Path 9522",
    d: "M311.368,97.2l-.253-.155-1.006-.584c-13.933-7.807-33.056-6.548-54.156,5.627V170.4c-9.959,5.753-18.033,19.735-18.033,31.227s8.074,16.176,18.033,10.409v68.321c42.621-24.616,77.183-84.469,77.183-133.694C333.136,122.548,324.837,105.464,311.368,97.2Z",
    transform: "translate(-220.857 -81.681)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9523",
    "data-name": "Path 9523",
    d: "M323.33,134.11a35.827,35.827,0,0,0-14.066-15.339c-12.421-7.167-28.6-5.922-45.716,3.517V129.6c.52-.324,1.048-.633,1.582-.942,9.34-5.394,18.286-8.116,26.269-8.116a28.991,28.991,0,0,1,14.657,3.714c10.163,5.866,16.015,18.111,16.634,34.66q.063,1.477.063,3c0,38.113-26.431,84.49-59.234,104.4v7.308l1.582-.886c35.279-20.4,64-70.086,64-110.822C329.1,151.061,327.114,141.657,323.33,134.11Z",
    transform: "translate(-228.452 -88.39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9524",
    "data-name": "Path 9524",
    d: "M314.323,178.509c0-15.86-5.514-27.781-15.529-33.563-9.628-5.556-22.091-4.677-35.243,2.455v7.322c.52-.324,1.048-.654,1.582-.956,7.033-4.051,13.708-6.1,19.693-6.1a21.388,21.388,0,0,1,10.831,2.757c7.976,4.607,12.364,14.58,12.364,28.084,0,28.7-19.8,63.559-44.443,78.772V264.6q.781-.422,1.582-.886C292.253,248.053,314.323,209.828,314.323,178.509Z",
    transform: "translate(-228.461 -96.448)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9525",
    "data-name": "Path 9525",
    d: "M299.532,195.106c0-11.3-3.974-19.82-11.2-23.983-6.829-3.946-15.579-3.418-24.785,1.407v7.308c.52-.331,1.048-.654,1.582-.957,4.677-2.7,9.143-4.072,13.061-4.072a13.778,13.778,0,0,1,6.977,1.772c5.176,2.989,8.032,9.565,8.032,18.5,0,19.278-13.166,42.671-29.652,53.143v7.3c.52-.274,1.048-.549,1.582-.858C284.1,243.74,299.532,217.007,299.532,195.106Z",
    transform: "translate(-228.461 -104.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_720",
    "data-name": "Ellipse 720",
    cx: 25.531,
    cy: 14.742,
    rx: 25.531,
    ry: 14.742,
    transform: "translate(9.561 124.323) rotate(-60)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_721",
    "data-name": "Ellipse 721",
    cx: 12.92,
    cy: 7.462,
    rx: 12.92,
    ry: 7.462,
    transform: "translate(22.17 116.831) rotate(-60)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_722",
    "data-name": "Ellipse 722",
    cx: 12.92,
    cy: 7.462,
    rx: 12.92,
    ry: 7.462,
    transform: "translate(22.17 116.831) rotate(-60)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9526",
    "data-name": "Path 9526",
    d: "M361.4,157.8l-8.334-2.307a15.192,15.192,0,0,0-6.112-.408c-5.873.816-18.286,2.532-21.2,2.884-3.8.464-5.7,5.479-3.066,9.607s8.813,9.671,27.816,8.292c0,0,9.333,24.251,32.571,10.838C389.946,182.756,385.142,165.532,361.4,157.8Z",
    transform: "translate(-245.645 -100.484)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9527",
    "data-name": "Path 9527",
    d: "M381.335,161.175a1.048,1.048,0,0,1-.429-.091c-1.716-.76-3.517-1.456-5.444-2.11l-4.691-1.3a1.055,1.055,0,1,1,.563-2.033l4.74,1.315a59.128,59.128,0,0,1,5.69,2.166,1.055,1.055,0,0,1-.429,2.019Z",
    transform: "translate(-260.033 -100.678)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9528",
    "data-name": "Path 9528",
    d: "M383.4,203.141c-7.469,0-12.66-4.22-16.008-8.355a1.056,1.056,0,1,1,1.646-1.322c3.939,4.923,10.845,9.959,21.416,6.281a1.059,1.059,0,0,1,.7,2A23.52,23.52,0,0,1,383.4,203.141Z",
    transform: "translate(-259.201 -111.797)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9529",
    "data-name": "Path 9529",
    d: "M420.7,165.708c2.061,7.125,6.745,28.034-3.714,43.606a5.352,5.352,0,0,1-5.268,2.3l-3.214-.485h0a3.1,3.1,0,0,0,2.433,3.017l33.084,7.251V159.28l-30.243,1.941,1.934.844a9.606,9.606,0,0,0,1.7.57h0a4.431,4.431,0,0,1,3.292,3.073Z",
    transform: "translate(-271.465 -101.772)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9530",
    "data-name": "Path 9530",
    d: "M438.823,162.965c2.743,8.313,7.378,28.7-3.474,50.133a5.479,5.479,0,0,1-6.063,2.855l-2.265-.492h0a3.348,3.348,0,0,0,2.989,3.692l36.791,3.812s5.247-8.285,5.247-35.215-7.6-31.98-7.6-31.98l-30.2,1.055a2.574,2.574,0,0,0-2.49,2.574h0l1.625-.105A5.352,5.352,0,0,1,438.823,162.965Z",
    transform: "translate(-276.954 -100.731)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9531",
    "data-name": "Path 9531",
    d: "M459.286,234.786a4.4,4.4,0,1,1-4.4-4.4,4.4,4.4,0,0,1,4.4,4.4Z",
    transform: "translate(-283.919 -122.869)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9532",
    "data-name": "Path 9532",
    d: "M380.851,157.74a1.132,1.132,0,0,1-.26,0,1.069,1.069,0,0,1-.767-1.287,5.528,5.528,0,0,0-.52-3.995,1.055,1.055,0,1,1,1.843-1.027,7.645,7.645,0,0,1,.7,5.542A1.048,1.048,0,0,1,380.851,157.74Z",
    transform: "translate(-262.763 -99.283)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9533",
    "data-name": "Path 9533",
    d: "M387.679,226.247a1.055,1.055,0,0,1-.492-1.983,9.945,9.945,0,0,0,5.078-7.526,1.061,1.061,0,0,1,2.11.218,11.957,11.957,0,0,1-6.182,9.143A1.062,1.062,0,0,1,387.679,226.247Z",
    transform: "translate(-264.977 -118.536)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9534",
    "data-name": "Path 9534",
    d: "M332.516,165.983h-.767a7.193,7.193,0,0,1-5.95-3.467.7.7,0,0,1,1.245-.654,5.87,5.87,0,0,0,4.811,2.722,18.61,18.61,0,0,0,6.133-.971c.6-.162,1.167-.366,1.329-.7a1.632,1.632,0,0,0,0-.879,8.967,8.967,0,0,0-1.006-2.616.7.7,0,1,1,1.217-.7,10.1,10.1,0,0,1,1.16,2.975,2.813,2.813,0,0,1-.063,1.723,3.143,3.143,0,0,1-2.258,1.533A22.3,22.3,0,0,1,332.516,165.983Z",
    transform: "translate(-246.908 -101.491)",
    fill: "#f28f8f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hand-1--inject-650",
    transform: "translate(9.1 81.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9535",
    "data-name": "Path 9535",
    d: "M101.393,265.59s-16.957,6.893-20.249,12.245-7.807,24.047-10,36.924-10.8,23.167-10.8,23.167l13.293,12.885,31.762-62.919Z",
    transform: "translate(-24.302 -149.064)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9536",
    "data-name": "Path 9536",
    d: "M131.853,243.451c0-49.233,34.561-109.085,77.19-133.694L192.015,99.91C149.436,124.59,114.91,184.372,114.91,233.6c0,25.65,9.389,43.346,24.412,50.935h0l15.037,8.806h0C140.441,285.242,131.853,267.983,131.853,243.451Z",
    transform: "translate(-40.492 -99.91)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9537",
    "data-name": "Path 9537",
    d: "M131.853,243.451c0-49.233,34.561-109.085,77.19-133.694L192.015,99.91C149.436,124.59,114.91,184.372,114.91,233.6c0,25.65,9.389,43.346,24.412,50.935h0l15.037,8.806h0C140.441,285.242,131.853,267.983,131.853,243.451Z",
    transform: "translate(-40.492 -99.91)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9538",
    "data-name": "Path 9538",
    d: "M139,247.607c0,24.525,8.581,41.784,22.464,49.887s33.337,7.033,54.725-5.317V223.863c-9.952,5.753-18.026,1.09-18.026-10.4s8.074-25.481,18.026-31.228V113.92C173.568,138.529,139,198.375,139,247.607Z",
    transform: "translate(-47.639 -104.066)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9539",
    "data-name": "Path 9539",
    d: "M221.095,140.336V133q-.788.429-1.582.886c-35.279,20.4-64,70.086-64,110.822,0,20.4,7.033,35.743,19.862,43.142a35.209,35.209,0,0,0,17.829,4.6c.738,0,1.484,0,2.237-.063,8.025-.429,16.7-3.109,25.636-8.025v-7.279c-.52.324-1.048.633-1.582.942q-1.477.851-2.954,1.618c-14.517,7.582-27.922,8.574-37.979,2.75-10.768-6.217-16.7-19.588-16.7-37.656C161.861,206.624,188.292,160.247,221.095,140.336Z",
    transform: "translate(-52.537 -109.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9540",
    "data-name": "Path 9540",
    d: "M225.76,268.159c-11.7,6.759-22.506,7.94-30.5,3.334S182.9,256.92,182.9,243.417c0-28.7,19.8-63.559,44.443-78.772V157.33c-.527.288-1.055.577-1.582.886-27.085,15.656-49.19,53.881-49.19,85.2,0,15.86,5.514,27.781,15.529,33.563a27.6,27.6,0,0,0,13.975,3.615c6.611,0,13.827-2.033,21.268-6.07V267.2C226.808,267.519,226.295,267.857,225.76,268.159Z",
    transform: "translate(-58.785 -116.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9541",
    "data-name": "Path 9541",
    d: "M232,258.3c-7.737,4.473-14.861,5.289-20.038,2.3s-8.032-9.565-8.032-18.5c0-19.278,13.159-42.671,29.652-53.143V181.64c-.527.274-1.048.556-1.582.865-18.99,10.951-34.4,37.677-34.4,59.585,0,11.3,3.974,19.82,11.2,23.983a19.932,19.932,0,0,0,10.121,2.63,32.248,32.248,0,0,0,14.664-4.065v-7.3C233.047,257.669,232.534,257.986,232,258.3Z",
    transform: "translate(-65.024 -124.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9542",
    "data-name": "Path 9542",
    d: "M139,247.607c0,24.525,8.581,41.784,22.464,49.887s33.337,7.033,54.725-5.317V223.863c-9.952,5.753-18.026,1.09-18.026-10.4s8.074-25.481,18.026-31.228V113.92C173.568,138.529,139,198.375,139,247.607Z",
    transform: "translate(-47.639 -104.066)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9543",
    "data-name": "Path 9543",
    d: "M158.643,328.132c7.687-1.878,13.912-11.464,13.912-11.464s6.745-27.254,17.056-26.86a3.664,3.664,0,0,1,3.481,4.03c-.443,4.466-5.162,22.281-7.673,30.848-3.052,10.43-21.332,26.389-21.332,26.389S150.963,330.031,158.643,328.132Z",
    transform: "translate(-52.751 -156.247)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9544",
    "data-name": "Path 9544",
    d: "M152.495,309.521c7.61-2.187,13.44-12.02,13.44-12.02s5.627-27.5,15.951-27.521a3.664,3.664,0,0,1,3.643,3.875c-.26,4.487-4.22,22.471-6.421,31.136-2.63,10.55-20.242,27.233-20.242,27.233S144.892,311.715,152.495,309.521Z",
    transform: "translate(-50.97 -150.366)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9545",
    "data-name": "Path 9545",
    d: "M174.847,333.347a1.146,1.146,0,0,1-.851-1.913c4.705-5.247,9.424-13.862,10.965-20.052,1.027-4.107,2.694-11.253,4.107-18.026a1.146,1.146,0,1,1,2.244.471c-1.231,5.873-2.891,13.152-4.122,18.111-1.653,6.611-6.485,15.473-11.492,21.029A1.125,1.125,0,0,1,174.847,333.347Z",
    transform: "translate(-57.934 -157.031)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9546",
    "data-name": "Path 9546",
    d: "M144.113,294c7.6-2.194,13.433-12.027,13.433-12.027s5.627-27.5,15.951-27.521a3.664,3.664,0,0,1,3.622,3.9c-.26,4.48-4.255,22.471-6.414,31.136-2.63,10.55-20.249,27.233-20.249,27.233S136.51,296.185,144.113,294Z",
    transform: "translate(-48.483 -145.759)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9547",
    "data-name": "Path 9547",
    d: "M108.62,287.811s5.549,6.6,13.152,4.417S135.206,280.2,135.206,280.2s5.627-27.5,15.951-27.521a3.664,3.664,0,0,1,3.643,3.882c-.26,4.48-4.255,22.471-6.414,31.136-2.63,10.55-20.249,27.233-20.249,27.233l-24.377-14.72Z",
    transform: "translate(-37.184 -145.234)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9548",
    "data-name": "Path 9548",
    d: "M141.248,359.143s-15.072,16.31-45.716,27.254L79.25,366l17.238-49,27.676,3.517S149.406,334.02,141.248,359.143Z",
    transform: "translate(-29.912 -164.316)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9549",
    "data-name": "Path 9549",
    d: "M148.765,309.32a1.132,1.132,0,0,1-.767-.288,1.146,1.146,0,0,1-.091-1.618c6.977-7.821,11.253-14.327,12.378-18.828,2.377-9.544,6.14-26.726,6.386-30.946a1.146,1.146,0,0,1,2.286.134c-.274,4.705-4.347,22.907-6.449,31.347-1.533,6.14-7.856,14.151-12.892,19.8A1.139,1.139,0,0,1,148.765,309.32Z",
    transform: "translate(-50.195 -146.402)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9550",
    "data-name": "Path 9550",
    d: "M162.515,319.046a1.125,1.125,0,0,1-.788-.316,1.139,1.139,0,0,1-.049-1.618c5.05-5.366,11.956-16.542,13.715-23.477,1.449-5.816,3.756-15.972,5.176-23.329a1.149,1.149,0,0,1,2.258.429c-1.407,7.4-3.756,17.583-5.212,23.456-1.864,7.476-9.017,18.912-14.27,24.49A1.146,1.146,0,0,1,162.515,319.046Z",
    transform: "translate(-54.274 -150.185)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9551",
    "data-name": "Path 9551",
    d: "M45.76,375.81,56.8,365.26s30.06,8.932,31.649,37.016l-9.762,6.97Z",
    transform: "translate(-19.977 -178.634)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9552",
    "data-name": "Path 9552",
    d: "M45.76,375.81,56.8,365.26s30.06,8.932,31.649,37.016l-9.762,6.97Z",
    transform: "translate(-19.977 -178.634)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9553",
    "data-name": "Path 9553",
    d: "M34.961,373.449c6.379,1.66,32.986,10.5,36.073,42.649a3.123,3.123,0,0,1-.872,2.469l-20.4,21.2S2.756,425.3,9.825,390.146L32.5,373.906A2.926,2.926,0,0,1,34.961,373.449Z",
    transform: "translate(-9.1 -181.034)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9554",
    "data-name": "Path 9554",
    d: "M84.166,429.733a4.023,4.023,0,1,1-4.023-4.023A4.023,4.023,0,0,1,84.166,429.733Z",
    transform: "translate(-28.984 -196.568)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9555",
    "data-name": "Path 9555",
    d: "M117.426,305.207a1.3,1.3,0,0,1-.331-.042,15.431,15.431,0,0,1-10.487-11.324,1.148,1.148,0,1,1,2.244-.492,13.258,13.258,0,0,0,8.9,9.614,1.146,1.146,0,0,1-.331,2.244Z",
    transform: "translate(-38.021 -157.031)",
    fill: "#f28f8f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sparkles--inject-650",
    transform: "translate(53.17 36.85)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_723",
    "data-name": "Ellipse 723",
    cx: 4.29,
    cy: 4.29,
    r: 4.29,
    transform: "translate(54.634 47.77)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_724",
    "data-name": "Ellipse 724",
    cx: 4.29,
    cy: 4.29,
    r: 4.29,
    transform: "translate(181.373 234.888)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9556",
    "data-name": "Path 9556",
    d: "M77.893,245.088a3.066,3.066,0,1,1-.888-2.18,3.067,3.067,0,0,1,.888,2.18Z",
    transform: "translate(-71.76 -97.714)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_725",
    "data-name": "Ellipse 725",
    cx: 3.059,
    cy: 3.059,
    r: 3.059,
    transform: "translate(202.296 32.353)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9557",
    "data-name": "Path 9557",
    d: "M126.5,166.405a2.11,2.11,0,1,1-2.11-2.145A2.152,2.152,0,0,1,126.5,166.405Z",
    transform: "translate(-86.748 -74.65)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9558",
    "data-name": "Path 9558",
    d: "M315.98,365.445a2.11,2.11,0,1,1-.618-1.527A2.11,2.11,0,0,1,315.98,365.445Z",
    transform: "translate(-142.963 -133.701)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9559",
    "data-name": "Path 9559",
    d: "M173.25,113.03a2.145,2.145,0,1,1-2.145-2.11,2.11,2.11,0,0,1,2.145,2.11Z",
    transform: "translate(-100.597 -58.825)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9560",
    "data-name": "Path 9560",
    d: "M360.26,348.1a2.145,2.145,0,1,1-2.145-2.145A2.145,2.145,0,0,1,360.26,348.1Z",
    transform: "translate(-156.079 -128.553)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9561",
    "data-name": "Path 9561",
    d: "M105,245.5a2.145,2.145,0,1,1-2.11-2.11A2.11,2.11,0,0,1,105,245.5Z",
    transform: "translate(-80.349 -98.126)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9562",
    "data-name": "Path 9562",
    d: "M385.62,117.1a2.11,2.11,0,1,1-2.11-2.145A2.152,2.152,0,0,1,385.62,117.1Z",
    transform: "translate(-163.624 -60.021)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9563",
    "data-name": "Path 9563",
    d: "M88.553,205.5l5.282,2.891-5.282,2.884-2.891,5.289-2.891-5.289-5.282-2.884,5.282-2.891,2.891-5.282Z",
    transform: "translate(-73.46 -85.318)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9564",
    "data-name": "Path 9564",
    d: "M289.393,387.642l5.282,2.891-5.282,2.891-2.891,5.282-2.891-5.282-5.282-2.891,5.282-2.891,2.891-5.282Z",
    transform: "translate(-133.045 -139.355)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9565",
    "data-name": "Path 9565",
    d: "M314.153,42.132l5.282,2.891-5.282,2.891L311.263,53.2l-2.891-5.282-5.282-2.891,5.282-2.891,2.891-5.282Z",
    transform: "translate(-140.391 -36.85)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9566",
    "data-name": "Path 9566",
    d: "M336.145,62.727l2.637,1.442-2.637,1.449L334.7,68.256l-1.442-2.637-2.645-1.449,2.645-1.442L334.7,60.09Z",
    transform: "translate(-148.555 -43.745)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9567",
    "data-name": "Path 9567",
    d: "M237.539,59.583l3.566,1.948-3.566,1.948-1.955,3.566-1.948-3.566-3.566-1.948,3.566-1.948,1.948-3.573Z",
    transform: "translate(-118.727 -42.534)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9568",
    "data-name": "Path 9568",
    d: "M237.635,390.815l2.637,1.442-2.637,1.449-1.449,2.637-1.442-2.637-2.645-1.449,2.645-1.442,1.442-2.644Z",
    transform: "translate(-119.329 -141.079)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9569",
    "data-name": "Path 9569",
    d: "M395.848,252.745l2.645,1.442-2.645,1.442-1.442,2.645-1.449-2.645-2.637-1.442,2.637-1.442,1.449-2.644Z",
    transform: "translate(-166.27 -100.117)",
    fill: "#4EB6EE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-650",
    transform: "translate(185.747 173.351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9570",
    "data-name": "Path 9570",
    d: "M387.967,279.7,346.478,255.91l-28.618,6.14,9.164,27.8,41.489,23.793-9.164-27.8Z",
    transform: "translate(-277.349 -238.341)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9571",
    "data-name": "Path 9571",
    d: "M387.967,279.7,346.478,255.91l-28.618,6.14,9.164,27.8,41.489,23.793-9.164-27.8Z",
    transform: "translate(-277.349 -238.341)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9572",
    "data-name": "Path 9572",
    d: "M336.73,294.105a.7.7,0,0,1-.668-.485l-7.272-22.049,9.629-2.068a.7.7,0,1,1,.3,1.372l-8.1,1.737,6.759,20.572a.7.7,0,0,1-.45.886.831.831,0,0,1-.2.035Z",
    transform: "translate(-280.591 -242.369)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9573",
    "data-name": "Path 9573",
    d: "M350.5,268.326a.707.707,0,0,1-.148-1.407l9.08-1.927a.722.722,0,0,1,.331,1.407l-9.143,1.913Z",
    transform: "translate(-286.801 -241.03)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9574",
    "data-name": "Path 9574",
    d: "M341.161,275.48a.707.707,0,0,1-.148-1.407l16.5-3.517a.7.7,0,0,1,.3,1.371l-16.5,3.517a.535.535,0,0,1-.148.035Z",
    transform: "translate(-284.03 -242.685)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9575",
    "data-name": "Path 9575",
    d: "M346.256,304.67a.7.7,0,0,1-.668-.485L342.894,296a.7.7,0,1,1,1.336-.443l2.694,8.194a.7.7,0,0,1-.443.886.841.841,0,0,1-.225.035Z",
    transform: "translate(-284.765 -249.959)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9576",
    "data-name": "Path 9576",
    d: "M379.367,285.185a.7.7,0,0,1-.169-1.386l7.1-1.526a.719.719,0,0,1,.3,1.407l-7.1,1.519A.529.529,0,0,1,379.367,285.185Z",
    transform: "translate(-295.383 -246.158)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9577",
    "data-name": "Path 9577",
    d: "M358.725,309.158a.7.7,0,0,1-.668-.485l-5.992-18.195a.7.7,0,1,1,1.336-.443l5.992,18.195a.7.7,0,0,1-.45.893A.79.79,0,0,1,358.725,309.158Z",
    transform: "translate(-287.485 -248.321)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9578",
    "data-name": "Path 9578",
    d: "M375.1,292.061a.707.707,0,0,1-.148-1.407l17.85-3.826a.7.7,0,1,1,.3,1.371l-17.85,3.826Z",
    transform: "translate(-294.099 -247.506)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9579",
    "data-name": "Path 9579",
    d: "M367.879,317.173a.7.7,0,0,1-.668-.485l-2.982-9.066a.7.7,0,0,1,1.336-.436l2.982,9.045a.7.7,0,0,1-.45.886A.787.787,0,0,1,367.879,317.173Z",
    transform: "translate(-291.097 -253.417)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9580",
    "data-name": "Path 9580",
    d: "M318.235,267.89a2.434,2.434,0,0,1-1.231-.331l-55.562-32.064a2.462,2.462,0,0,1,2.462-4.262L319.466,263.3a2.462,2.462,0,0,1-1.231,4.593Z",
    transform: "translate(-260.26 -230.93)",
    fill: "#263238"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedgoalsAmico);
export default __webpack_public_path__ + "static/media/Shared goals-amico.467a399a4be03ed6dc795212c9e5c72b.svg";
export { ForwardRef as ReactComponent };